import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import H from "../../../common/Typography/H";
import TextField from "../../../common/TextField";
import Button from "../../../common/Button";
import {openServiceModal} from "../../ducks/service-modal";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";

import styles from "./search.module.scss";

function Search(props) {
  return (
    <div className={styles.root}>
      <H level={2} className={styles.title}>
        Не нашли, что искали?
      </H>
      <div className={styles.content}>
        <form action="/store" className={styles.input}>
          <TextField
            label="Поиск по сайту"
            fullWidth={true}
            name="q"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        </form>
        <span className={styles.separator}>или</span>
        <Button
          variant="contained"
          size="medium"
          style="primary"
          className={styles.button}
          onClick={props.openServiceModal}
        >
          Напишите нам
        </Button>
      </div>
    </div>
  );
}

Search.propTypes = {
  openServiceModal: PropTypes.func
};

export default connect(null, {
  openServiceModal
})(Search);
